import React, { useState, useRef } from 'react';

import { useTranslation } from "react-i18next";

 

const PhoneInput = ({ value, onChange, error, disabled }) => {
  const { t } = useTranslation("auth");
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);
  const formatPhoneNumber = (inputValue) => {
    if (!inputValue) return '';

    const digits = String(inputValue).replace(/\D/g, '');

    if (digits.length === 0) return '';

    let phoneDigits = digits;
    if (!digits.startsWith('998')) {
      phoneDigits = '998' + digits;
  }

  phoneDigits = phoneDigits.slice(0, 12);

  const country = '+998';
  const operator = phoneDigits.slice(3, 5);   
  const part1 = phoneDigits.slice(5, 8);     
  const part2 = phoneDigits.slice(8, 10);     
  const part3 = phoneDigits.slice(10, 12);    
  


  let formatted = country;
  if (operator) formatted += ` (${operator}`;
  if (operator.length === 2) formatted += `)`;
  if (part1) formatted += ` ${part1}`;
  if (part2) formatted += `-${part2}`;
  if (part3) formatted += `-${part3}`;

  return formatted;
};


  const handleInputChange = (e) => {
    if (!e || !e.target) return;
    
    const newValue = formatPhoneNumber(e.target.value);
    onChange(newValue);
  };

  const handleKeyDown = (e) => {

    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Home', 'End'
    ];
    
    if (allowedKeys.includes(e.key)) {
      return;
    }
    

    if (e.ctrlKey && ['a', 'c', 'v', 'x', 'z'].includes(e.key.toLowerCase())) {
      return;
    }
    

    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
    if (!value || value === '') {
      onChange('+998 ');
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (value === '+998 ' || value === '+998') {
      onChange('');
    }
  };


  const isValid = value && value.replace(/\D/g, '').length >= 12 && !error;

  return (
    <div className="w-full">
      <div className="relative">
        {/* Иконка телефона */}
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <svg 
            className={`w-5 h-5 transition-colors duration-200 ${
              isFocused ? 'text-blue-500' : error ? 'text-red-500' : 'text-gray-400'
            }`}
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" 
            />
          </svg>
        </div>

        {/* Поле ввода */}
        <input
          ref={inputRef}
          type="tel"
          value={value || ''}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder="+998 99 819 24 92"
          disabled={disabled}
          className={`
            w-full mx-auto pl-8 pr-4 py-3 !text-xl font-mono !text-black
            border-2 rounded-xl 
            transition-all duration-200 ease-in-out
            placeholder:text-gray-400 placeholder:font-sans
            focus:outline-none focus:ring-0
            disabled:bg-gray-50 disabled:cursor-not-allowed
            ${error 
              ? 'border-red-300 bg-red-50 text-red-900 focus:border-red-500' 
              : isFocused
                ? 'border-blue-500 bg-white shadow-lg shadow-blue-500/10'
                : 'border-gray-300 bg-white hover:border-gray-400'
            }
          `}
        />

        {/* Индикатор валидности */}
        {isValid && (
          <div className="absolute inset-y-0 right-0 pr-4 flex items-center">
            <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
              <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
        )}
      </div>

      {/* Сообщение об ошибке */}
      {error && (
        <div className="mt-2 flex items-center text-red-600">
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-sm">{error}</span>
        </div>
      )}

      {/* Подсказка по формату */}
      {!error && isFocused && (
        <div className="mt-2 text-xm text-gray-500">
          {t("PHONE_FORMAT")}: +998 99 999 99 99
        </div>
      )}
    </div>
  );
};

export default PhoneInput;